/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { useWorkspace } from '@/hooks/workspace';
import { useTranslation } from 'react-i18next';

import { Table, Td } from '../components/table';
import { useReport } from './hooks/use-context';

function ReportDetails() {
  const { header } = useReport();
  const { workspaceData } = useWorkspace();
  const { t } = useTranslation();

  if (!header) return null;

  const {
    event_date_time,
    event_created_at,
    event_finished_at,
    author_email,
    hide_score,
    score_obtained,
    total_score,
    local,
    percent_score,
    fantasy_name,
    company_name,
    address,
    document: companyDocument,
    ticket_code_seq,
  } = header;

  function formatDate(dateString: string) {
    const [datePart, timePart] = dateString.split(' ');
    const [hours, minutes] = timePart.split(':');
    return `${datePart} ${hours}:${minutes}`;
  }

  return (
    <div
      style={{
        width: '100%',
        fontSize: '0.875rem',
        fontWeight: 'bold',
      }}
    >
      <Table>
        <tbody>
          {/* <tr>
            <Td>Tipo do evento</Td>
            <Td>{event_type}</Td>
          </tr>
          <tr>
            <Td>Nome do evento</Td>
            <Td>{event_name}</Td>
          </tr> */}

          {!!ticket_code_seq && workspaceData.name === 'ellodist' && (
            <tr>
              <Td>Ticket</Td>
              <Td>TK-{ticket_code_seq}</Td>
            </tr>
          )}

          {!!(event_created_at || event_date_time) && (
            <tr>
              <Td>{t('pdf_report.started_at')}</Td>
              <Td>{event_created_at || formatDate(event_date_time)}</Td>
            </tr>
          )}

          <tr>
            <Td>{t('pdf_report.finished_at')}</Td>
            <Td>{!!event_finished_at && event_finished_at}</Td>
          </tr>

          <tr>
            <Td>{t('pdf_report.author')}</Td>
            <Td>{author_email}</Td>
          </tr>

          {!hide_score && !!total_score && (
            <tr>
              <Td>{t('pdf_report.checklist_score')}</Td>
              <Td>
                {score_obtained?.toFixed(1)} / {total_score} - {percent_score}%
              </Td>
            </tr>
          )}

          {!!local && (
            <tr>
              <Td>{t('pdf_report.event_location')}</Td>
              <Td>
                {` ${local.name}`}
                {local.address ? `, ${local.address}` : null}
                {local.city ? `, ${local.city}` : null}
                {local.state ? `, ${local.state}` : null}
              </Td>
            </tr>
          )}

          {!(!header.company_name || !header.fantasy_name) && (
            <tr>
              <Td>{t('pdf_report.company_data')}</Td>
              <Td>
                {fantasy_name ? ` ${fantasy_name}` : ''}
                {company_name ? ` - ${company_name}` : ''}
                {companyDocument ? `, ${companyDocument}` : ''}
                {address ? `, ${address}` : ''}
              </Td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

export function Header() {
  const { header } = useReport();
  const { workspaceData } = useWorkspace();

  if (!header) return null;

  return (
    <div
      style={{
        marginBottom: '2rem',
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: '2.5rem',
        color: '#475569',
        pageBreakAfter: 'avoid',
      }}
    >
      {workspaceData.name !== 'ellodist' && (
        <h1
          style={{
            fontSize: '1.875rem',
            fontWeight: 500,
            lineHeight: '1.25',
          }}
        >
          {header.event_name}
        </h1>
      )}
      <ReportDetails />
    </div>
  );
}
